import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProviderProfileRoutingModule } from './provider-profile-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ProviderProfileRoutingModule
  ]
})
export class ProviderProfileModule { }
